module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (127).087e6587.jpg";